<template>
  <div class="flex flex-wrap gap-2">
    <span 
      v-for="(item, index) in items"
      :key="index"
      class="text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded-full shadow-sm"
    >
      {{ item }}
    </span>
    <span v-if="!items || items.length === 0" class="text-xs text-gray-500 italic">
      {{ emptyText }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ChipListDisplay',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    emptyText: {
      type: String,
      default: 'N/A'
    }
  }
};
</script>

<style scoped>
/* Scoped styles for ChipListDisplay */
</style> 